import type { AssetKind } from '../types';

/** Cosa preparare nello slot nascosto. `url` è un URL blob: di cui `Surfaces` diventa proprietaria (lo revoca). */
export interface PrepareSpec {
  assetId: string;
  scheduleId: string | null;
  kind: AssetKind;
  url: string;
  offsetMs: number;
  /** Durata prevista del contenuto (null = a tempo indefinito), per la pagina "Live". */
  durationMs?: number | null;
}

/** Le due superfici sovrapposte (A/B). Il controller non conosce il DOM, solo questa interfaccia. */
export interface Surfaces {
  /** Prepara nello slot nascosto (video: carica e posiziona in pausa; immagine: decode). Sostituisce una preparazione precedente. */
  prepare(spec: PrepareSpec): Promise<void>;
  /** Porta in primo piano quanto preparato, senza mai lasciare lo schermo vuoto. Rifiuta se non c'è nulla di pronto. */
  commit(): Promise<void>;
  discardPrepared(): void;
  /** Schermo nero: svuota entrambi gli slot. */
  showBlack(): void;
  visibleSlot(): string | null;
  /** Posizione (ms) del video in onda, o null. */
  positionMs(): number | null;
  setRate(rate: number): void;
  seekMs(ms: number): void;
  onEnded(cb: () => void): void;
  onError(cb: (msg: string) => void): void;
}

/** `prepare` annullata da una preparazione/scarto successivo: non è un errore dell'asset. */
export class SupersededError extends Error {
  constructor() {
    super('preparazione superata');
    this.name = 'SupersededError';
  }
}

export interface AssetProvider {
  isReady(assetId: string, sha256: string): boolean;
  getUrl(assetId: string, sha256: string): Promise<string>;
}

export interface Scheduler {
  setTimeout(fn: () => void, ms: number): unknown;
  clearTimeout(handle: unknown): void;
}

export const SYSTEM_SCHEDULER: Scheduler = {
  setTimeout: (fn, ms) => setTimeout(fn, ms),
  clearTimeout: (h) => clearTimeout(h as ReturnType<typeof setTimeout>),
};
